// extracted by mini-css-extract-plugin
export default {"wrapper":"RecalculateButton_wrapper__X93PT","icon":"RecalculateButton_icon__JbIvN","isLoading":"RecalculateButton_isLoading__j0dAq","rotate":"RecalculateButton_rotate__AV101"};